"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    dialogContentClassNames: ()=>dialogContentClassNames,
    useDialogContentStyles_unstable: ()=>useDialogContentStyles_unstable
});
const _react = require("@griffel/react");
const dialogContentClassNames = {
    root: 'fui-DialogContent'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react["__styles"])({
    root: {
        Bmxbyg5: "f5zp4f",
        sshi5w: "f1nxs5xn",
        B7ck84d: "f1ewtqcl",
        z8tnut: "fr4fn7s",
        z189sj: [
            "f171n1a0",
            "f1jwbs5a"
        ],
        Byoj8tv: "f1ean75l",
        uwmqm3: [
            "f1jwbs5a",
            "f171n1a0"
        ],
        B6of3ja: "fxlnl9e",
        t21cq0: [
            "ffs23cn",
            "f1v5tmjd"
        ],
        jrapky: "f2uu7rc",
        Frg6f3: [
            "f1v5tmjd",
            "ffs23cn"
        ],
        Ijaq50: "f6owso0",
        Br312pm: "fupswjn",
        nk6f5a: "foucsne",
        Bw0ie65: "f1ka72gx",
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi"
    }
}, {
    d: [
        ".f5zp4f{overflow-y:auto;}",
        ".f1nxs5xn{min-height:32px;}",
        ".f1ewtqcl{box-sizing:border-box;}",
        ".fr4fn7s{padding-top:var(--strokeWidthThick);}",
        ".f171n1a0{padding-right:var(--strokeWidthThick);}",
        ".f1jwbs5a{padding-left:var(--strokeWidthThick);}",
        ".f1ean75l{padding-bottom:var(--strokeWidthThick);}",
        ".fxlnl9e{margin-top:calc(var(--strokeWidthThick) * -1);}",
        ".ffs23cn{margin-right:calc(var(--strokeWidthThick) * -1);}",
        ".f1v5tmjd{margin-left:calc(var(--strokeWidthThick) * -1);}",
        ".f2uu7rc{margin-bottom:calc(var(--strokeWidthThick) * -1);}",
        ".f6owso0{grid-row-start:body;}",
        ".fupswjn{grid-column-start:body;}",
        ".foucsne{grid-row-end:body;}",
        ".f1ka72gx{grid-column-end:body;}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}"
    ]
});
const useDialogContentStyles_unstable = (state)=>{
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(dialogContentClassNames.root, styles.root, state.root.className);
    return state;
}; //# sourceMappingURL=useDialogContentStyles.js.map

//# sourceMappingURL=useDialogContentStyles.js.map